var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".8vw",
    height: ".75vw",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_311_22748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10677 7.16898C1.10643 8.38831 1.42503 9.57889 2.03084 10.6283L1.04883 14.2138L4.71813 13.2517C5.73301 13.8042 6.87011 14.0937 8.02563 14.0937H8.02867C11.8433 14.0937 14.9484 10.9897 14.9501 7.17443C14.9508 5.32566 14.2315 3.5872 12.9246 2.27928C11.6179 0.971463 9.88002 0.250844 8.02839 0.25C4.21334 0.25 1.1084 3.35388 1.10682 7.16898",
    fill: "url(#paint0_linear_311_22748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.859992 7.16715C0.859598 8.43036 1.18962 9.66353 1.81703 10.7505L0.799805 14.4645L4.60067 13.4679C5.64794 14.0389 6.82705 14.34 8.02686 14.3404H8.02996C11.9814 14.3404 15.1981 11.1247 15.1998 7.17289C15.2005 5.25769 14.4553 3.45673 13.1017 2.10195C11.7479 0.747337 9.94791 0.0007875 8.02996 0C4.07783 0 0.861567 3.21525 0.859992 7.16715ZM3.12355 10.5633L2.98163 10.338C2.38504 9.38942 2.07015 8.29322 2.0706 7.1676C2.07184 3.88288 4.74507 1.2105 8.03221 1.2105C9.62408 1.21118 11.1201 1.83173 12.2453 2.95763C13.3705 4.08364 13.9896 5.58045 13.9893 7.17244C13.9878 10.4572 11.3145 13.1299 8.02996 13.1299H8.02759C6.95811 13.1293 5.90922 12.8421 4.99448 12.2993L4.77679 12.1703L2.52128 12.7616L3.12355 10.5633Z",
    fill: "url(#paint1_linear_311_22748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23791 4.17113C6.10369 3.87284 5.96245 3.86682 5.83482 3.86159C5.73031 3.85709 5.61083 3.85743 5.49147 3.85743C5.37199 3.85743 5.17787 3.90237 5.01379 4.08153C4.84954 4.26085 4.38672 4.6942 4.38672 5.57558C4.38672 6.45697 5.0287 7.30882 5.11819 7.42846C5.2078 7.54788 6.35755 9.41448 8.17847 10.1326C9.69182 10.7293 9.99979 10.6106 10.3282 10.5807C10.6567 10.5509 11.3882 10.1475 11.5374 9.72914C11.6868 9.31087 11.6868 8.95233 11.642 8.8774C11.5972 8.80276 11.4778 8.75793 11.2986 8.66838C11.1194 8.57883 10.2386 8.14537 10.0744 8.08557C9.91019 8.02583 9.79077 7.99602 9.67129 8.1754C9.55182 8.3545 9.20875 8.75793 9.10418 8.8774C8.99972 8.99716 8.89515 9.01207 8.71606 8.92246C8.53679 8.83257 7.95983 8.64363 7.27532 8.03337C6.74275 7.55851 6.3832 6.9721 6.27869 6.79272C6.17417 6.61362 6.26749 6.51653 6.35732 6.42727C6.43782 6.347 6.53654 6.21807 6.6262 6.1135C6.71552 6.00888 6.74534 5.93423 6.80507 5.81476C6.86487 5.69517 6.83494 5.59055 6.79022 5.50094C6.74534 5.41133 6.39721 4.52534 6.23791 4.17113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_22748",
    x1: 696.11,
    y1: 1396.63,
    x2: 696.11,
    y2: 0.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_311_22748",
    x1: 720.8,
    y1: 1446.45,
    x2: 720.8,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_22748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.5125,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.8e03149a3b1c3546b2954fc343a57def.svg";
export { ForwardRef as ReactComponent };